import { Box, Typography, Button } from '@mui/material';
import Seo from '../components/Seo';
import PageShell from '../components/PageShell';

const bullets = [
  {
    title: 'Real installs, not ad clicks',
    body: "Every install through BingePlay comes from a user who actually played a level of your game. They didn't tap a banner ad by accident. They tapped download because the gameplay clicked.",
  },
  {
    title: 'No ad spend to start',
    body: "Post a gamic. It enters the discovery feed. The algorithm surfaces it to gamers whose play history suggests they'll love it. You don't pay per impression. You pay attention to what works.",
  },
  {
    title: 'Real feedback loop',
    body: 'Likes, comments, retention on the playable. See how players actually feel about your level before you spend a cent on user acquisition.',
  },
  {
    title: 'Built for solo devs and studios',
    body: "Whether you're shipping your first indie title or your tenth, BingePlay gives you a low friction distribution channel that compounds with quality.",
  },
];

export default function ForDevelopers() {
  return (
    <PageShell>
      <Seo
        path="/for-developers"
        title="For Game Developers"
        description="Get installs from players who already loved your gameplay. BingePlay gives indie game developers a TikTok style discovery channel built around playable demos."
      />
      <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, maxWidth: 1100, mx: 'auto' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            component="h1"
            sx={{
              color: '#fff',
              fontFamily: 'Rammetto One',
              textTransform: 'uppercase',
              fontWeight: 800,
              fontSize: { xs: 30, sm: 44, md: 56, lg: 64 },
              lineHeight: 1.1,
              mt: { xs: 2, sm: 4 },
            }}
          >
            Stop paying $4 CPI to lose users in 24 hours.
          </Typography>
          <Typography
            sx={{
              color: '#ddd',
              fontFamily: 'Poppins',
              mt: { xs: 2, sm: 3 },
              fontSize: { xs: 14, sm: 18, md: 20 },
              maxWidth: 720,
              mx: 'auto',
            }}
          >
            BingePlay gives indie game developers a TikTok style discovery channel built around
            playable demos. Players try one level. If it lands, they install.
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: { xs: 3, md: 4 },
            mt: { xs: 5, sm: 7 },
          }}
        >
          {bullets.map((b) => (
            <Box
              key={b.title}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                backgroundColor: 'rgba(255,255,255,0.08)',
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  fontFamily: 'Rammetto One',
                  textTransform: 'uppercase',
                  fontSize: { xs: 18, md: 22 },
                  mb: 1.5,
                }}
              >
                {b.title}
              </Typography>
              <Typography
                sx={{
                  color: '#ddd',
                  fontFamily: 'Poppins',
                  fontSize: { xs: 14, md: 16 },
                  lineHeight: 1.55,
                }}
              >
                {b.body}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ textAlign: 'center', mt: { xs: 6, sm: 8 } }}>
          <Button
            href="https://app.funizzle.com/login"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              px: { xs: 3, sm: 4 },
              py: { xs: 1.2, sm: 1.6 },
              borderRadius: '12px',
              fontFamily: 'Poppins',
              fontSize: { xs: '1rem', sm: '1.125rem' },
              bgcolor: '#ef4444',
              '&:hover': { bgcolor: '#dc2626', transform: 'scale(1.04)' },
              transition: '0.25s',
            }}
          >
            Submit Your Gamic
          </Button>
          <Typography
            sx={{
              color: '#bbb',
              fontFamily: 'Poppins',
              fontSize: { xs: 12, sm: 14 },
              mt: 2,
              letterSpacing: '0.04em',
            }}
          >
            Or join the dev community →{' '}
            <Box
              component="a"
              href="https://discord.com/invite/mN8ENbzEMJ"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#fff', textDecoration: 'underline' }}
            >
              Discord
            </Box>
          </Typography>
        </Box>
      </Box>
    </PageShell>
  );
}
